<template>
  <div>
    <div class="alert alert-info">
      <p>
        Eine Asa ist ein Wiederanschreiben eines Mitglieds, nach dem dieses
        Mitglied bereits in einem Dialog geschrieben hat, aber nicht mehr
        antwortet. Sprich, die Moderation hat die letzte Nachricht geschrieben.
      </p>
      <p>
        Eine Asa Stufe entspricht einer Nachricht. Das heißt, Wenn im System
        eine ASA Stufe eingetragen ist, wird das Mitglied nach der letzten
        Nachricht eines Moderators ein weiteres Mal angeschrieben. Bei 10 ASA
        Stufen wird das Mitglied 10 Mal erneut angeschrieben.
      </p>
    </div>
    <resource
      resource="asa"
      resourceName="ASA"
      :attributes="[
        {
          name: 'days',
          label: 'Tage'
        },
        {
          name: 'hours',
          label: 'Stunden'
        },
        {
          name: 'minutes',
          label: 'Minuten'
        },
        {
          name: 'tolerance',
          label: 'Toleranz (in Minuten)'
        }
      ]"
    >
      <div slot="title">
        <h4>ASA erstellen</h4>
      </div>
    </resource>
  </div>
</template>

<script lang="babel">
export default {}
</script>
